/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   sps\clients\identity\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Contracts = require("VSS/Identities/Mru/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods2To7_2 extends VSS_WebApi.VssHttpClient {
    protected mruIdentitiesApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Obsolete]
     *
     * @param {Contracts.MruIdentitiesUpdateData} updateData
     * @param {string} identityId
     * @param {string} containerId
     * @return IPromise<void>
     */
    public updateMruIdentities(
        updateData: Contracts.MruIdentitiesUpdateData,
        identityId: string,
        containerId: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PATCH",
            httpResponseType: "html",
            area: "Identity",
            locationId: "15d952a1-bb4e-436c-88ca-cfe1e9ff3331",
            resource: "MruIdentities",
            routeTemplate: "_apis/{area}/{resource}/containers/{containerId}/users/{identityId}",
            routeValues: {
                identityId: identityId,
                containerId: containerId
            },
            apiVersion: this.mruIdentitiesApiVersion,
            data: updateData
        });
    }

    /**
     * [Preview API]
     *
     * @param {string[]} identityIds
     * @param {string} identityId
     * @param {string} containerId
     * @return IPromise<void>
     */
    public setMruIdentities(
        identityIds: string[],
        identityId: string,
        containerId: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PUT",
            httpResponseType: "html",
            area: "Identity",
            locationId: "15d952a1-bb4e-436c-88ca-cfe1e9ff3331",
            resource: "MruIdentities",
            routeTemplate: "_apis/{area}/{resource}/containers/{containerId}/users/{identityId}",
            routeValues: {
                identityId: identityId,
                containerId: containerId
            },
            apiVersion: this.mruIdentitiesApiVersion,
            data: identityIds
        });
    }

    /**
     * [Preview API]
     *
     * @param {string} identityId
     * @param {string} containerId
     * @return IPromise<string[]>
     */
    public getMruIdentities(
        identityId: string,
        containerId: string
        ): IPromise<string[]> {

        return this._beginRequest<string[]>({
            httpMethod: "GET",
            area: "Identity",
            locationId: "15d952a1-bb4e-436c-88ca-cfe1e9ff3331",
            resource: "MruIdentities",
            routeTemplate: "_apis/{area}/{resource}/containers/{containerId}/users/{identityId}",
            responseIsCollection: true,
            routeValues: {
                identityId: identityId,
                containerId: containerId
            },
            apiVersion: this.mruIdentitiesApiVersion
        });
    }
}

export class CommonMethods6_1To7_2 extends CommonMethods2To7_2 {
    protected mruIdentitiesV2ApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Preview API] We needed to create a new resource entirely because of the breaking change, all inheirited methods are pointing to the resource location id used in MruIdentitiesController.
     *
     * @param {Contracts.MruIdentitiesUpdateData} updateData
     * @param {string} identityId
     * @param {string} containerId
     * @return IPromise<string[]>
     */
    public addMruIdentitiesAndRemoveInactive(
        updateData: Contracts.MruIdentitiesUpdateData,
        identityId: string,
        containerId: string
        ): IPromise<string[]> {

        return this._beginRequest<string[]>({
            httpMethod: "PATCH",
            area: "Identity",
            locationId: "c46f9443-1fa7-47d4-8df5-513c0e6c8003",
            resource: "MruIdentitiesV2",
            routeTemplate: "_apis/{area}/{resource}/containers/{containerId}/{action}/users/{identityId}",
            responseIsCollection: true,
            routeValues: {
                identityId: identityId,
                containerId: containerId,
                action: "AddMruIdentities"
            },
            apiVersion: this.mruIdentitiesV2ApiVersion,
            data: updateData
        });
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient7_2 extends CommonMethods6_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion =
        this.mruIdentitiesV2ApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient7_1 extends CommonMethods6_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion =
        this.mruIdentitiesV2ApiVersion = "7.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient7 extends CommonMethods6_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion =
        this.mruIdentitiesV2ApiVersion = "7.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient6_1 extends CommonMethods6_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion =
        this.mruIdentitiesV2ApiVersion = "6.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient6 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "6.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient5_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "5.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient5_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "5.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient5 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "5.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient4_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "4.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient4 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "4.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient3_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "3.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient3_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "3.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "3.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient2_3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "2.3-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient2_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "2.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient2_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "2.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class IdentityMruHttpClient2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.mruIdentitiesApiVersion = "2.0-preview.1";
    }
}

export class IdentityMruHttpClient extends IdentityMruHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": IdentityMruHttpClient7_2,
    "7.1": IdentityMruHttpClient7_1,
    "7.0": IdentityMruHttpClient7,
    "6.1": IdentityMruHttpClient6_1,
    "6.0": IdentityMruHttpClient6,
    "5.2": IdentityMruHttpClient5_2,
    "5.1": IdentityMruHttpClient5_1,
    "5.0": IdentityMruHttpClient5,
    "4.1": IdentityMruHttpClient4_1,
    "4.0": IdentityMruHttpClient4,
    "3.2": IdentityMruHttpClient3_2,
    "3.1": IdentityMruHttpClient3_1,
    "3.0": IdentityMruHttpClient3,
    "2.3": IdentityMruHttpClient2_3,
    "2.2": IdentityMruHttpClient2_2,
    "2.1": IdentityMruHttpClient2_1,
    "2.0": IdentityMruHttpClient2
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return IdentityMruHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): IdentityMruHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<IdentityMruHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<IdentityMruHttpClient7_1>(IdentityMruHttpClient7_1, undefined, undefined, undefined, options);
    }
}
